import {
  CreditCardOutlined,
  DownloadOutlined,
  MinusCircleOutlined,
  UploadOutlined,
  WalletOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';
import type { JSX, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { OperationType } from '../api/types';

export const OP_TYPE_ICON: Record<OperationType, ReactNode> = {
  PURCHASE: <DownloadOutlined />,
  ISSUE: <UploadOutlined />,
  STORE_PAYMENT: <WalletOutlined />,
  SKLAD_PAYMENT: <CreditCardOutlined />,
  EXPENSE: <MinusCircleOutlined />,
};

export const OP_TYPE_COLOR: Record<OperationType, string> = {
  PURCHASE: 'blue',
  ISSUE: 'green',
  STORE_PAYMENT: 'cyan',
  SKLAD_PAYMENT: 'orange',
  EXPENSE: 'red',
};

export function OpTypeTag({ type }: { type: OperationType }): JSX.Element {
  const { t } = useTranslation();
  return (
    <Tag icon={OP_TYPE_ICON[type]} color={OP_TYPE_COLOR[type]} style={{ marginInlineEnd: 0 }}>
      {t(`opType.${type}`)}
    </Tag>
  );
}
